import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import { env } from '~/commons/config';

import PageLittleChallenge from './PageLittleChallenge.jsx';

const root = document.getElementById('little-challenge');

if (root) {
  ReactDOM.render(
    (
      <Router basename={env.base}>
        <Switch>
          <Route exact path="/little-challenge">
            <PageLittleChallenge />
          </Route>
        </Switch>
      </Router>
    ),
    root,
  );
}
